module.exports = "data:image/gif;base64,R0lGODlhDgAJAIAAAAAAAP///yH5BAUUAAEALAAAAAAOAAkAAAISjI+pewDmWIjzMUoTttpmCYYFADs="